module.exports = __webpack_public_path__ + "static/media/pink_colour.4f66b6cf.png";